import React, { useEffect, useState } from "react";
import DropdownPrime from "../PrimeComponents/DropdownPrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";
const GraficadorRow = ({ nodesInfo, dropdownData, t, obj, index, updateRow,  removeRow, addRowNextNodo, addRowNextSensor, rowsLength, rows }) => {
    const [color, setColor] = useState(obj.color);
    const [sensorDisabled, setSensorDisabled] = useState(true);
    const [deleteDisabled, setDeleteDisabled] = useState(false);
    //var obj = {node: null, sensor: null, color: color};
    useEffect(() => {
        if (rowsLength >= 6) {
            setSensorDisabled(true);
        } else {
            onNodeChange(false);
            onSensorChange(false);
        }

        if (rowsLength === 1) {
            setDeleteDisabled(true);
        } else {
            setDeleteDisabled(false);
        }
        if(obj.sensor){
            setSensorDisabled(false);
        }
    }, [obj, rowsLength]);

    const onNodeChange = (update, nodeInfo) => {
        let i = -1;
        const nodo = nodesInfo.find((node, index) => {
            if (nodeInfo?.nodo_id === node.nodo_id) { i = index; return node; }
            return false;
        });
        const nodoData = dropdownData.find((node, index) => {
            if (nodeInfo?.nodo_id === node.nodo_id) { i = index; return node; }
            return false;
        });
        if (nodo) {
            obj.nodo = {};
            obj.nodo.id = nodo.nodo_id;
            obj.nodo.nombre = nodo.nombre;
            obj.nodo.lastNode = nodoData.lastNode;
            if (update) updateRow(index, obj);
        }
    };

    const onSensorChange = (update, sensorInfo) => {
        if(sensorInfo){
            let _sensorList = "sensores";
            let _sensorId = "sensor_id";
            if(t("graficador.sensor_virtual")===sensorInfo.tipo){
                _sensorList = "derivados";
                _sensorId = "sensor_virtual_derivado_id";
            }
            else if(t("graficador.sensor_sistema")===sensorInfo.tipo){
                _sensorList = "sist_sensores";
                _sensorId = "sist_sensor_id";
            }
            const nodo = nodesInfo.find(node => sensorInfo?.nodo_id === node.nodo_id);
            if (nodo && nodo[_sensorList]) {
                let i = -1;
                const sensor = nodo?.[_sensorList]?.find((sensor, index) => {
                    if (sensorInfo.original_id === sensor?.[_sensorId] || sensorInfo.sensor_id === sensor?.[_sensorId]) { i = index; return sensor; }
                    return false;
                });
                if (sensor) {
                    obj.sensor = sensor;
                    obj.sensor.ddData = sensorInfo;
                    obj.sensor.original_id=sensorInfo.original_id;
                    obj.sensor.sensor_id=sensorInfo.sensor_id;
                    if ((i >= 0 && i + 1 === nodo[_sensorList].length) || index >= 5) {
                        setSensorDisabled(true);
                    } else {
                        setSensorDisabled(false);
                    }
                } else {
                    obj.sensor = null;
                    setSensorDisabled(true);
                }
            } else {
                obj.sensor = null;
                setSensorDisabled(true);
            }
            if (update) updateRow(index, obj);
        }
    };
    const onColorChange = (colorValue) => {
        setColor(colorValue);
        obj.color = colorValue;
        updateRow(index, obj);
    };
    return (
        <div className='row'>
            <div className="col-12 col-md-3 text-md-center mtem-05">
                <DropdownPrime
                    value={dropdownData?.find(n => n?.nodo_id === obj?.nodo?.id)}
                    onChange={(e) => { onNodeChange(true, e.value); }}
                    options={dropdownData} optionLabel="nombre"
                    placeholder={t("graficador.node")}
                    name="nodo_id"
                    showClear={false}
                />
            </div>
            <div className="col-12 col-md-1 text-md-center mtem-05">
                {
                    rowsLength >= 6 || obj?.nodo?.lastNode ?
                        null
                        :
                        <ButtonPrime t={t} template="formPlus"
                            onClick={(e) => { addRowNextNodo(index); }}
                        />
                }
            </div>
            <div className="col-12 col-md-3 text-md-center mtem-05">
                <DropdownPrime
                    value={obj?.sensor?.ddData}
                    onChange={(e) => { onSensorChange(true, e.value); }}
                    options={dropdownData?.find(n => n?.nodo_id === obj?.nodo?.id)?.sensores??[]} optionLabel="nombre"
                    optionGroupChildren="items" optionGroupLabel="label"
                    placeholder={t("graficador.sensor")}
                    name="sensor_id"
                    showClear={false}
                />
            </div>
            <div className="col-12 col-md-1 text-md-center mtem-05">
                {
                    sensorDisabled || rowsLength >= 6 || obj?.sensor?.ddData?.lastSensor?
                        null
                        :
                        <ButtonPrime t={t} template="formPlus"
                            onClick={(e) => { addRowNextSensor(index, obj?.sensor?.ddData?.tipo);}}
                            disabled={sensorDisabled}
                        />
                }
            </div>
            <div className="col-12 col-md-2 text-md-center mtem-05">
                <input type="color" onChange={(e) => { onColorChange(e.target.value); }} value={color} style={{ width: 30, height: 30 }} />
            </div>
            <div className="col-12 col-md-2 text-md-center mtem-05">
                {
                    deleteDisabled && rowsLength === 1?
                        null
                        :
                        <ButtonPrime t={t} template="formRemove"
                            onClick={(e) => { removeRow(index); }}
                            disabled={deleteDisabled}
                        />
                }
            </div>
        </div>
    );
};

export default GraficadorRow;
